<template>
	<div>
		<page-title-bar></page-title-bar>
		<app-section-loader :status="loader"></app-section-loader>

  	<v-container fluid grid-list-xl py-0>
			<v-layout row wrap>
				<app-card
					:fullBlock="true"
					colClasses="xl12 lg12 md12 sm12 xs12 xs12 xs12"
				>
					<v-card-title>{{kindForm}}
						<v-spacer></v-spacer>
						<v-text-field
							append-icon="search"
							label="Search"
							single-line
							hide-details
							v-model="search"
						>
						</v-text-field>
					</v-card-title>
					<v-data-table
						v-bind:headers="headers"
						v-bind:items="items"
						:rows-per-page-items="[-1]"
					>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.FirstName }} {{ props.item.LastName }}</td>
							<td>{{ props.item.Address }}</td>
							<td class="text-xs-left">{{ props.item.ZipCode }} {{ props.item.City }}</td>
							<td>{{ props.item.Email }}</td>
						  <td></td>
							<td><v-btn icon  @click="editRec (props.item)"><v-icon small>edit</v-icon></v-btn></td>
						</template>
						<template slot="pageText" slot-scope="{ pageStart, pageStop }">
							From {{ pageStart }} to {{ pageStop }}
						</template>
					</v-data-table>
				</app-card>

				<v-dialog v-model="dialog2" max-width="500">
						<v-card>
							<v-card-title class="headline">Klant verwijderen?</v-card-title>
							<v-card-text>Ben je zeker dat je <strong> {{this.currentRec.FirstName}} {{this.currentRec.LastName}} </strong> wenst te verwijderen ?</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="warning" flat="flat" @click.native="dialog2 = false">Nee</v-btn>
								<v-btn color="error" flat="flat" @click.native="delRec(currentRec)">Ja</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

			</v-layout>
  	</v-container>
	</div>
</template>

<script>
import myHttpApi from "../../api/myHttpApi";
import router from '../../router';
import Vue from 'vue';

export default {
	props: ['kindrec'],
  data() {
    return {
			dialog2: false,
			currentRec : '',
			loader: true,
      max25chars: v => v.length <= 25 || "Input too long!",
      tmp: "",
      search: "",
			pagination: {},
			kindForm : 'Klanten',
      headers: [
        { text: "Naam", value: "FirstName LastName"  },
				{ text: "Adres", value: "Address"  },
				{ text: "Stad", value: "City"  },
				{ text: "Email", value: "Email" },
			  { text: "", value: "", width: "30px"},
				{ text: "Wijzig", value: "Mod", width: "30px"  },
      ],
			items: []
    };
  },
  mounted() {
		this.search = Vue.$lastSearchCustomers;
		console.log (this.search);
		this.getTablesData();
  },
  methods: {
    getTablesData() {
			myHttpApi
			
		this.kindForm = 'Klanten';
		if (this.kindrec == 1) {this.kindForm = 'Leveranciers';}

		const searchRec = {Search: this.search, Extra: this.kindrec}
		myHttpApi.post( 'BOCustomer/Search', searchRec)
        .then(response => {
					this.loader = false;
					this.items = [];
					this.items = response.data.Result;
					Vue.$lastSearchCustomers = this.search;
        })
        .catch(error => {
          console.log(error);
        });
		},
		 editRec(rec){
			 this.currentRec = rec;
			 router.push({name:'customerdet', params: {id: rec.CustomerID, kindrec: this.kindrec, isNew: false } });
		},
		askDel(rec){
			this.currentRec = rec;
			this.dialog2 = true;
		}
  },
  watch: {
    search(after, before) {
			console.log (before + ": " + after);
            this.getTablesData();
		},
		kindrec(newId, oldId) {
       this.getTablesData();
    }
	}
};
</script>
